import React from 'react';

const values = [
    { icon: '🛡️', title: 'Fully Insured', desc: "Every shipment is insured. If something goes wrong, you're covered." },
    { icon: '📍', title: 'Live Tracking', desc: 'Real-time GPS tracking for every delivery, accessible to you and your clients.' },
    { icon: '🤝', title: 'Dedicated Account Manager', desc: 'Business clients get a dedicated contact — one call solves everything.' },
    { icon: '📦', title: 'All Package Sizes', desc: 'From envelopes to pallets, our fleet handles it all with care.' },
];

export default function About() {
    return (
        <section id="about" className="bg-[#f8f8f6] lg-custom:py-20 py-12">
            <div className="dh-container">
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }} className="about-grid">
                    <div>
                        <div className="uppercase" style={{
                            display: 'inline-block', background: '#fefce8', color: '#a38900',
                            borderRadius: '100px', padding: '3px 14px', fontSize: '12px',
                            fontFamily: "'Inter'", fontWeight: 500, marginBottom: '13px', letterSpacing: '0.5px',
                        }}>
                            our story
                        </div>
                        <h2 style={{
                            fontFamily: "'Bebas Neue'",
                            fontWeight: 900,
                            fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                            lineHeight: '0.95',
                            marginBottom: '1.5rem',
                        }}>
                            built by<br/>someone who<br/>knows the<br/><span className="text-dh-blue">market.</span>
                        </h2>
                        <p style={{ color: '#5c5c56', fontSize: '16px', fontFamily: "'Inter'", lineHeight: 1.7, marginBottom: '16px' }}>
                            Delivery Hub Lebanon was born from a simple truth: Lebanese entrepreneurs deserved a logistics partner that actually
                            understands their world. Not a faceless courier company — a team that knows what it takes to build a business here, from
                            the first sale to the thousandth delivery.
                        </p>
                        <p style={{ color: '#5c5c56', fontSize: '16px', fontFamily: "'Inter'", lineHeight: 1.7, marginBottom: '16px' }}>
                            That insight comes from the ground up. Our founder spent over 16 years on the frontlines of Lebanese consumer tech retail,
                            working directly with merchants, understanding supply chains, and watching e-commerce grow from a novelty into the
                            backbone of modern commerce. When the logistics gap became impossible to ignore, Delivery Hub was the answer.
                        </p>
                        <p style={{ color: '#5c5c56', fontSize: '16px', fontFamily: "'Inter'", lineHeight: 1.7, marginBottom: '50px' }}>
                            Today, we are the operational backbone for online businesses across Lebanon — handling storage, packing, and delivery so
                            our partners can focus entirely on growth.
                        </p>
                        <div className="grid lg-custom:grid-cols-4 grid-cols-2 gap-2.5">
                            <div className={'lg-custom:p-5 p-3 rounded-lg'} style={{
                                textAlign: 'center',
                                background: '#fff',
                                border: '1px solid #e0dfd6',
                            }}>
                                <p style={{
                                    fontFamily: "'Bebas Neue'",
                                    fontWeight: 900,
                                    fontSize: '2.5rem',
                                    color: '#0a4abe',
                                    lineHeight: 1
                                }}>16+</p>
                                <p style={{ fontFamily: "'Inter'", fontSize: '12px', color: '#9e9d95', marginTop: '4px' }}>Years Market Experience</p>
                            </div>
                            <div className={'lg-custom:p-5 p-3 rounded-lg'} style={{
                                textAlign: 'center',
                                background: '#fff',
                                border: '1px solid #e0dfd6',
                            }}>
                                <p style={{
                                    fontFamily: "'Bebas Neue'",
                                    fontWeight: 900,
                                    fontSize: '2.5rem',
                                    color: '#0a4abe',
                                    lineHeight: 1
                                }}>20+</p>
                                <p style={{ fontFamily: "'Inter'", fontSize: '12px', color: '#9e9d95', marginTop: '4px' }}>Districts Served</p>
                            </div>
                            <div className={'lg-custom:p-5 p-3 rounded-lg'} style={{
                                textAlign: 'center',
                                background: '#fff',
                                border: '1px solid #e0dfd6',
                            }}>
                                <p style={{
                                    fontFamily: "'Bebas Neue'",
                                    fontWeight: 900,
                                    fontSize: '2.5rem',
                                    color: '#0a4abe',
                                    lineHeight: 1
                                }}>24H</p>
                                <p style={{ fontFamily: "'Inter'", fontSize: '12px', color: '#9e9d95', marginTop: '4px' }}>Avg. Turnaround</p>
                            </div>
                            <div className={'lg-custom:p-5 p-3 rounded-lg'} style={{
                                textAlign: 'center',
                                background: '#fff',
                                border: '1px solid #e0dfd6',
                            }}>
                                <p style={{
                                    fontFamily: "'Bebas Neue'",
                                    fontWeight: 900,
                                    fontSize: '2.5rem',
                                    color: '#0a4abe',
                                    lineHeight: 1
                                }}>2024</p>
                                <p style={{ fontFamily: "'Inter'", fontSize: '12px', color: '#9e9d95', marginTop: '4px' }}>Year Founded</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-dh-blue border-t-4  border-t-dh-yellow rounded-md lg-custom:p-[3rem] p-6 relative">
                        <div className="font-mono text-xs text-neutral-100/75 uppercase mb-[1.5rem]">founder & managing director</div>
                        <div className="founder-name" style={{
                            fontFamily: "'Bebas Neue'",
                            fontWeight: 900,
                            fontSize: 'clamp(2.5rem, 3vw, 3rem)',
                            lineHeight: '0.95',
                            marginBottom: '0.5rem',
                            color: '#ffffff'
                        }}>HASAN<br/>FAKIH
                        </div>

                        <div className="text-white" style={{
                            fontFamily: "'Inter'",
                            fontWeight: 500,
                            fontSize: '0.85rem',
                            color: '#fadd00',
                            marginBottom: '1.5rem',
                        }}>Founder & Managing Director · Delivery Hub Lebanon
                        </div>

                        <div className="text-white/80 text-sm" style={{
                            fontFamily: "'Inter'",
                            fontWeight: 300,
                            marginBottom: '1.7rem',
                        }}>Hasan Fakih brings over 16 years of hands-on experience in Lebanon's consumer technology sector. Since 2008, he built his
                            expertise
                            on the retail floor — working at Ayoub Computers, one of Lebanon's most established tech retail chains — where he
                            developed a rare and
                            detailed understanding of how Lebanese businesses buy, sell, and scale.
                        </div>

                        <div className="text-white/80 text-sm" style={{
                            fontFamily: "'Inter'",
                            fontWeight: 300,
                            marginBottom: '1.7rem',
                        }}>That background gave Hasan something most logistics founders don't have: an insider's view of what merchants actually need.
                            He saw how e-commerce entrepreneurs were underserved — juggling deliveries, storage, and returns with no reliable partner
                            to lean on. In 2024, he founded Delivery Hub Lebanon to close that gap permanently, building a company designed to be a
                            genuine operational partner, not just a courier.
                        </div>
                    </div>

                    {/*<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>*/}
                    {/*  {values.map(v => (*/}
                    {/*      <div key={v.title} style={{*/}
                    {/*        background: '#ffffff', border: '1px solid #e0dfd6', borderRadius: '16px',*/}
                    {/*        padding: '24px', transition: 'box-shadow 0.2s',*/}
                    {/*      }}*/}
                    {/*           onMouseEnter={e => e.currentTarget.style.boxShadow = '0 8px 32px rgba(10,74,190,0.08)'}*/}
                    {/*           onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}*/}
                    {/*      >*/}
                    {/*        <div style={{ fontSize: '28px', marginBottom: '14px' }}>{v.icon}</div>*/}
                    {/*        <h3 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: '15px', marginBottom: '8px', color: '#0d0d0d' }}>{v.title}</h3>*/}
                    {/*        <p style={{ fontFamily: "'Inter'", fontSize: '13px', color: '#5c5c56', lineHeight: 1.6 }}>{v.desc}</p>*/}
                    {/*      </div>*/}
                    {/*  ))}*/}
                    {/*</div>*/}
                </div>
            </div>

            <style>{`
        @media (max-width: 900px) {
          .about-grid { grid-template-columns: 1fr !important; gap: 48px !important; }
        }
      `}</style>
        </section>
    );
}